import axios from 'axios'
import { i18n } from '../../plugins/i18n'
import { castAttributesForCamelCase } from '../../modules/string_converter'

export const companiesMediaLibraryStores = {
  namespaced: true,
  state: {
    data: null,
    meta: null,
    loading: false,
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    readMediaLibraryStoresSuccess(state, payload) {
      state.data = payload.data.map(data => {
        let castData = castAttributesForCamelCase(data)
        return castData
      })
      state.meta = castAttributesForCamelCase(payload.meta)

      state.loading = false
    },
    apiSuccess(state) {
      state.loading = false
    },
    apiFailure(state) {
      state.loading = false
    },
  },
  actions: {
    readMediaLibraryStores({ commit, rootState }, query) {
      commit('prepareConnect')

      return axios
        .get('/api/companies/' + rootState.route.params.company_uuid + '/media/libraries/' + rootState.route.params.id + '/stores' + `?per=${query.per}&page=${query.page}`)
        .then(res => {
          commit('readMediaLibraryStoresSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    deleteMediaLibraryStore({ commit, state, rootState }, { storeUuid, mediaLibraryId }) {
      if (state.loading) return

      commit('prepareConnect')
      return axios
        .delete('/api/companies/' + rootState.route.params.company_uuid + '/media/libraries/' + mediaLibraryId + '/stores/' + storeUuid)
        .then(() => {
          commit('apiSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.discontinuedUse') }, { root: true })
          return true
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
  }
}
